export default __webpack_public_path__ + "static/media/likeActiveIcon.fbf29e93.svg";